import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Camera, DollarSign, RefreshCcw, ImageIcon, Package } from "lucide-react";

interface KpiPipelineSectionProps {
  metrics?: {
    camerasQuoted: number;
    camerasOnOrder: number;
    revenueQuoted: number;
    revenueOnOrder: number | null;
    arrQuoted: number;
    imagesPipeline: number;
  };
}

export const KpiPipelineSection = ({ metrics }: KpiPipelineSectionProps) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const formatNumber = (value: number) => {
    return new Intl.NumberFormat('en-GB').format(value);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <span className="inline-block w-3 h-3 rounded-full bg-lime-button" />
        <h2 className="text-2xl font-semibold text-foreground">Pipeline (Quoted)</h2>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card className="border-l-4 border-lime-button">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Cameras Quoted
            </CardTitle>
            <Camera className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatNumber(metrics?.camerasQuoted || 0)}
            </div>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-lime-button">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Cameras On Order
            </CardTitle>
            <Package className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatNumber(metrics?.camerasOnOrder || 0)}
            </div>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-lime-button">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Revenue Quoted
            </CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatCurrency(metrics?.revenueQuoted || 0)}
            </div>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-lime-button">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Revenue On Order
            </CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-muted-foreground">
              TBD
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              Requires sales linkage
            </p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-lime-button">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              ARR Quoted
            </CardTitle>
            <RefreshCcw className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatCurrency(metrics?.arrQuoted || 0)}
            </div>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-lime-button">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              Images Pipeline
            </CardTitle>
            <ImageIcon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold text-foreground">
              {formatNumber(metrics?.imagesPipeline || 0)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
